import './App.css';
import Main from './components/MainComponent';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './redux/store';
import { Auth0ProviderWithNavigate } from './components/Auth0ProviderWithNavigateComponent';
import { useEffect, useRef } from 'react';

function App() {


  const appRef = useRef(null); // Create a reference for the App container

  useEffect(() => {
    const updateHeight = () => {
      if (!appRef.current) return;
      const vh = window.innerHeight * 0.01;
      appRef.current.style.setProperty('--vh', `${vh}px`);
    };

    updateHeight(); // Call on initial load

    window.addEventListener('resize', updateHeight); // Update on resize
    return () => window.removeEventListener('resize', updateHeight); // Cleanup
  }, []);


  return (
    <Provider store={store}>
        <BrowserRouter>
            <Auth0ProviderWithNavigate>
                <div className="App" ref={appRef}>
                    <Main />
                </div>
            </Auth0ProviderWithNavigate>
        </BrowserRouter>
    </Provider>
  );
}

export default App;
